// src/components/base/DisruptionAlert/DisruptionAlert.tsx
import { Link } from '../Link/Link';
import { SvgIcon } from '../Icon/SvgIcon';
// type
import type { DisruptionLink } from '../../../arcticapi/types';
// styles
import styles from './DisruptionAlert.module.css';

export interface DisruptionAlertProps {
  disruption?: DisruptionLink | null;
}

export function DisruptionAlert({ disruption }: DisruptionAlertProps) {
  const count = disruption?.count ?? 0;

  if (count < 1) {
    return null;
  }

  const suffix = count === 1 ? '' : 's';
  const label = `${count} active service update${suffix}`;

  // Note that DisruptionAlerts will render in multiple places across the widget.
  return (
    <div className={styles.wrapper}>
      <div className={styles.warningIconContainer}>
        <SvgIcon
          className={styles.warningIcon}
          name="caution"
          viewBox="0 0 71 48"
        ></SvgIcon>
      </div>
      <div className={styles.labelWrapper}>{label}</div>
      {disruption?.href && (
        <div className={styles.linkWrapper}>
          <Link href={disruption.href} isExternal>
            Show details
          </Link>
        </div>
      )}
      <div className={styles.unionIconContainer}>
        <SvgIcon
          className={styles.unionIcon}
          name="union"
          viewBox="0 0 136 48"
        ></SvgIcon>
      </div>
    </div>
  );
}
